import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { AUTH_ROUTES } from '@features/authentication/authentication.routes';
import { APPLICATIONS_ROUTES } from '@features/applications/applications.routes';
import { DASHBOARD_ROUTES } from '@features/dashboard/dashboard.routes';
import { USAGE_ROUTES } from '@features/usage/usage.routes';
import { DOCS_ROUTES } from '@features/docs/docs.routes';
import { MARKETPLACE_ROUTES } from '@features/marketplace/marketplace.routes';
import { PLAYGROUND_ROUTES } from '@features/playground/playground.routes';
import { SETTINGS_ROUTES } from '@features/settings/settings.routes';

export const routes: Routes = [
  // Full-screen auth pages — no layout shell, no authGuard.
  ...AUTH_ROUTES,
  // The public marketplace — browsable logged out, own header, no shell.
  {
    path: 'apps',
    loadComponent: () =>
      import('@features/marketplace/public/apps-grid.component').then((m) => m.AppsGridComponent),
  },
  {
    path: 'apps/:slug',
    loadComponent: () =>
      import('@features/marketplace/public/app-public-detail.component').then(
        (m) => m.AppPublicDetailComponent,
      ),
  },
  {
    path: '',
    loadComponent: () => import('@core/layout/layout.component').then((m) => m.LayoutComponent),
    canActivate: [authGuard],
    children: [
      ...DASHBOARD_ROUTES,
      // Before APPLICATIONS_ROUTES: `applications/:id/marketplace` would
      // otherwise be captured by the `applications/:id` detail route.
      ...MARKETPLACE_ROUTES,
      ...APPLICATIONS_ROUTES,
      ...USAGE_ROUTES,
      ...DOCS_ROUTES,
      ...PLAYGROUND_ROUTES,
      ...SETTINGS_ROUTES,
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
